import { DisplayViewController } from './display-view.controller';
import { DisplayViewComponentProps } from './display-view.model';

const DisplayView = (props: DisplayViewComponentProps) => {
  return <DisplayViewController {...props} />;
};

export default DisplayView;
